import { useParams, Link } from 'react-router-dom';
import { useMemo, useEffect } from 'react';
import { articles, categories } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = useMemo(() => categories.find((c) => c.slug === slug) || categories[0], [slug]);
  const categoryArticles = useMemo(
    () => articles.filter((a) => a.categorySlug === slug),
    [slug]
  );

  useEffect(() => {
    if (category) {
      document.title = `${category.name} - 17黑料网 | 网红黑料追踪`;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', `${category.description} 17黑料网${category.name}频道，每日更新最新${category.name}资讯。`);
      }
    }
  }, [category]);

  if (!category) {
    return (
      <main>
        <Navbar />
        <div className="min-h-[60vh] flex items-center justify-center bg-background-50 pt-16">
          <p className="text-foreground-500">分类不存在</p>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main>
      <Navbar />

      <section className="relative w-full h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden pt-16">
        <div className="absolute inset-0 top-16">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20stage%20backdrop%20with%20dramatic%20crimson%20and%20charcoal%20gradient%2C%20flowing%20fabric%20texture%2C%20luxurious%20theater%20atmosphere%2C%20cinematic%20lighting%2C%20mysterious%20elegant%20mood%2C%20no%20people%2C%20artistic%20abstract%20composition&width=1920&height=600&seq=category-hero-generic&orientation=landscape"
            alt={`${category.name} - 17黑料网`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl font-black text-white mb-3">
            {category.name}
          </h1>
          <p className="font-heading text-base md:text-lg italic text-white/70 font-light">
            {category.nameEn}
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />
        </div>
      </section>

      <section className="bg-background-50 pb-6">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-label transition-all duration-200 whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-white shadow-sm'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
          <div className="mb-8">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              全部{category.name}
            </h2>
            <p className="text-sm text-foreground-500 mt-2">{category.description}</p>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article, index) => (
                <ArticleCard
                  key={article.id}
                  {...article}
                  variant={index === 0 ? 'featured' : 'default'}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">暂无相关文章</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
}